import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { interval, SubscriptionLike } from 'rxjs';

@Component({
  selector: 'app-errorbanner',
  template: `<p class="text-success fs-14 text-center m-0 py-2">
  <i class="fas fa-check-circle text-success"></i>&nbsp;{{Content.message}}
  <span class="error_close" (click)='messageClose()'>
    <i class="fas fa-times"></i>
  </span>
</p>`,
styles: [
]
})
export class ErrorbannerComponent implements OnInit,OnDestroy {
  subInterval :SubscriptionLike;
  @Input() public Content: any;

  constructor(
    public ngModal: NgbActiveModal
  ) { }
  ngOnDestroy(): void {
    if(this.subInterval)
    this.subInterval.unsubscribe();
  }
  ngOnInit(): void {
    this.subInterval = interval(5 * 1000).subscribe(() => { this.messageClose(); });
  }

  messageClose() {
   this.ngModal.dismiss();
  }
}


